import React, { useLayoutEffect, useState } from 'react';
import * as Sentry from '@sentry/react';
import Gleap from 'gleap';
import Joi from 'joi';
import Cookies from 'js-cookie';
import { setStorage } from '../../utils/auth-utils';
import { isJsrStorageKey } from '../../utils/constants';
import { setStorageObject } from '../../utils/global';
import FallbackLoader from '../common-components/Loaders/FallbackLoader';

const impersonationSchema = Joi.object({
  token: Joi.string().required(),
  userId: Joi.string().hex().length(24).required(),
});

export default function Impersonate() {
  const [error, setError] = useState('');

  useLayoutEffect(() => {
    const params = new URLSearchParams(window.location.hash.slice(1));
    // Remove credentials before analytics effects run or navigation adds history entries.
    window.history.replaceState(null, '', window.location.pathname);
    const result = impersonationSchema.validate({ token: params.get('token'), userId: params.get('userId') });
    if (result.error) {
      setError('Invalid impersonation link. Please try again from the admin dashboard.');
      return;
    }

    const { token } = result.value;
    setStorage('token', token);
    Cookies.set('access_token', token, { expires: 15 });
    setStorageObject(isJsrStorageKey, { isJsrLogin: true });
    Sentry.setUser(null);
    Gleap.clearIdentity();
    // Reload to discard the previous account's Redux state and cached API data.
    window.location.replace('/dashboard');
  }, []);

  if (error) {
    return (
      <div role="alert" className="p-6 text-center">
        {error}
      </div>
    );
  }
  return <FallbackLoader />;
}
